<template lang="pug">
  #pageSeriesForm

    confirm-dialog(ref="cdConfirmModal" :title="cdParameters.title" :text="cdParameters.text" :buttonPosition="cdParameters.buttonPosition" :width="cdParameters.width" @close="cdAction")

    #pageHeader
      h2.blockTitle
        | Criar série
        span(v-if="groupData && groupData.nome" v-html="': ' + groupData.nome")

    #blockSeriesForm

      v-card-text

        v-row

          v-col

            form(@submit.prevent="save").px-4

              template(v-if="!groupId")
                v-row

                  v-col(cols="12" md="6")
                    .sosField.mb-5
                      sos-select(
                        label="INFORME O GRUPO DA SÉRIE"
                        :items="groups"
                        :default="selectedGroupId"
                        @sosSelectChanged="setSelectedGroup"
                      )

              template(v-if="groupId || selectedGroupId")
                v-row
                  .seriesSubtitle.seriesSubtitle--clearTop(style="color: red;")
                    | CARACTERÍSTICAS DA SÉRIE

                v-row

                  v-col(cols="12" md="6")
                    .saveSeriesField.saveSeriesField--first
                      label.csLabel
                        span(v-html="'Nome'")
                      .csFields
                        input(
                          v-model="name"
                          class="sosInput"
                          maxlength="255"
                          placeholder="EX.: JORNADA PADRÃO DE TRABALHO"
                          :disabled="loadingGroupData || loading"
                        )
                        .fieldError(v-if="touched && !name").mt-5
                          | Você deve informar um nome

                  v-col(cols="12" md="6")
                    .sosField
                      sos-select(
                        label="TIPO DE SÉRIE"
                        :items="seriesTypes"
                        :default="type"
                        @sosSelectChanged="setType"
                      )
                      .fieldError(v-if="touched && !type").mt-5
                        | Você deve informar o tipo de série

                  v-col(cols="12" md="6")
                    .saveSeriesField
                    label.csLabel
                      span(v-html="'Período'")
                    .csFields
                      date-picker(
                        v-model="period"
                        placeholder="Clique aqui e selecione"
                        :clearable="false"
                        :editable="false"
                        :multiple="false"
                        type="date"
                        :range="true"
                        valueType="format"
                        format="DD/MM/YYYY"
                        :lang="dateLanguage"
                        class="w-100"
                        :disabled="loadingGroupData || loading"
                      )
                      .fieldError(v-if="touched && !period").mt-5
                        | Você deve informar o período

                  v-col(cols="12" md="6")
                    .sosField
                      sos-select(
                        label="REPETIÇÃO"
                        :items="filteredSerieRepetitionTypes"
                        :default="repetition"
                        @sosSelectChanged="setRepetition"
                        :disabled="loadingGroupData || loading"
                      )
                      .fieldError(v-if="touched && !repetition").mt-5
                        | Você deve informar o tipo de repetição

                    v-row

                      v-col(cols="12")
                        template(v-if="repetition === weeklyRepetition")
                          .saveSeriesField.mt-5
                            .csFields
                            sos-select(
                              label="DIAS DA SEMANA"
                              :items="weekdaysList"
                              @sosSelectChanged="setWeekdays"
                              defaultEmpty="Selecione os dias da semana"
                              :default="''"
                              :multiple="true"
                              :fullscreen="true"
                              fullscreenTitle="Dias da semana"
                              :disabled="loadingGroupData || loading"
                            )
                            .fieldError(v-if="touched && repetition === weeklyRepetition && !weekdays.length").mt-3
                              | Escolha pelo menos um dia da semana

                      v-col(cols="12")
                        template(v-if="repetition === monthlyRepetition")
                          .sosField
                            sos-select(
                              label="Tipo de repetição mensal"
                              :items="monthlyRepetitionTypes"
                              :default="monthlyRepetitionType"
                              @sosSelectChanged="setMonthlyRepetitionType"
                              :disabled="loadingGroupData || loading"
                            )
                            .fieldError(v-if="touched && repetition === monthlyRepetition && !monthlyRepetitionType")
                              | Informe o tipo da repetição

                v-row
                  .seriesSubtitle.seriesSubtitle--clearTop(style="color: red;")
                    | USUÁRIOS DA SÉRIE

                v-row

                  v-col(cols="12")
                    .saveSeriesField
                      sos-select(
                        label="ESCALAS"
                        :items="scalesList"
                        @sosSelectChanged="setScales"
                        defaultEmpty="Selecione as escalas"
                        :default="''"
                        :multiple="true"
                        :fullscreen="true"
                        fullscreenTitle="Escalas"
                        :fullscreenAutoWidth="true"
                        :disabled="loadingGroupData || loading"
                      )
                      .fieldError(v-if="touched && !scales.length").mt-3
                        | Informe pelo menos uma escala

                  v-col(cols="12")
                    .saveSeriesField
                      sos-select(
                        label="TURNOS"
                        :items="turnsList"
                        @sosSelectChanged="setTurns"
                        defaultEmpty="Selecione os turnos"
                        :default="''"
                        :multiple="true"
                        :fullscreen="true"
                        fullscreenTitle="Turnos"
                        :disabled="loadingGroupData || loading"
                      )
                      .fieldError(v-if="touched && !turns.length").mt-3
                        | Informe pelo menos um turno

                  v-col(cols="12")
                    .saveSeriesField
                      sos-select(
                        label="USUÁRIOS"
                        :items="usersList"
                        @sosSelectChanged="setUsers"
                        defaultEmpty="Selecione os usuários"
                        :default="''"
                        :multiple="true"
                        :fullscreen="true"
                        fullscreenTitle="Usuários"
                        :disabled="loadingGroupData || loading"
                      )
                      .fieldError(v-if="touched && !users.length").mt-3
                        | Informe pelo menos um usuário

                template(v-if="type === workingDayType")
                  v-row
                    .seriesSubtitle.seriesSubtitle--clearTop(style="color: red;")
                      | DEFINIÇÃO DE VALOR

                  v-row.mb-5

                    v-col(cols="12")
                      .sosField
                        sos-select(
                          label="VALOR DO PLANTÃO"
                          :items="dutyValueSourceTypes"
                          :default="dutyValueSource"
                          @sosSelectChanged="setDutyValueSource"
                          :disabled="loadingGroupData || loading"
                        )
                        .fieldError(v-if="touched && !dutyValueSource").mt-5
                          | Você deve o valor do plantão

                    template(v-if="dutyValueSource === dutyValueSourceUserGroup || dutyValueSource === dutyValueSourceUserScale")
                      v-col(cols="12")
                        label.csLabel
                          span(v-html="'OBS.: CASO NÃO HAJA VALOR DEFINIDO, SERÁ UTILIZADO O VALOR PADRÃO POR HORA DO GRUPO'")

                    template(v-if="dutyValueSource === dutyValueSourceCustom")
                      v-col(cols="12")
                        label.csLabel
                          span(v-html="'Valor total do plantão'")
                        .csFields
                          app-money-light(:value="dutyCustomValue" :blur-event="onBlurDutyCustomValue" :disabled="loadingGroupData || loading")
                            .fieldError(v-if="touched && dutyValueSource === dutyValueSourceCustom && !dutyCustomValue").mt-5
                              | Você deve informar o valor total do plantão

                v-row(justify="space-between").mt-5
                  sos-button(@buttonClick="openCancelDialog" size="medium" buttonLabel="VOLTAR" buttonIcon="mdi-arrow-left" buttonIconSize="16" :disabled="loadingGroupData || loading")
                  sos-button(type="submit" size="medium" :buttonLabel="loading ? 'PROCESSANDO...' : 'SALVAR SÉRIE'" color="success" buttonIcon="mdi-content-save" buttonIconSize="16" :disabled="loadingGroupData || loading" :loading="loading")

</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import moment from "moment";
import StringMixin from "@/mixins/string.mixin";
import StepHeader from "@/components/StepHeader";
import SosSelect from "@/components/SosSelect";
import AppMoneyLight from "@/components/base/AppMoneyLight";
import SosButton from "@/components/SosButton";
import * as types from "@/store/group-series/types";
import dateTimeLanguage from "@/constants/dateTimeLanguage";
import weekdaysValues from "@/constants/weekdays";
import ConfirmDialog from "@/modals/ConfirmDialog";
import confirmDialogMixin from "@/mixins/cd.mixin.js";
import {
  SERIES_VACATION,
  SERIES_WORKING_DAY,
  SERIES_REPETITION_DAILY,
  SERIES_REPETITION_WEEKLY,
  SERIES_REPETITION_MONTHLY,
  SERIES_REPETITION_MONTHLY_ON_WEEKDAY,
  SERIES_REPETITION_MONTHLY_ON_DAY_OF_MONTH,
} from "@/constants/series";
import {
  DUTY_VALUE_SOURCE_CUSTOM,
  DUTY_VALUE_SOURCE_USER_GROUP,
  DUTY_VALUE_SOURCE_USER_SCALE,
} from "@/constants/dutyValueSources";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { formatDbTime, calculateEndTime } from '@/mixins/utils'
import {  valueToTime } from '@/functions'

export default {
  name: "SaveSeriesForm",

  components: {
    StepHeader,
    DatePicker,
    "sos-button": SosButton,
    "app-money-light": AppMoneyLight,
    "confirm-dialog": ConfirmDialog,
    "sos-select": SosSelect,
    "date-picker": DatePicker,
  },

  mixins: [StringMixin, confirmDialogMixin],

  props: {
    groupId: {
      type: String,
      default: null,
    },
    id: {
      type: String,
      default: null,
    },
  },

  data: () => ({
    loading: false,
    selectedGroupId: "",
    name: "",
    type: "",
    repetition: "",
    weekdays: [],
    monthlyRepetitionType: "",
    period: undefined,
    scales: [],
    turns: [],
    users: [],
    dutyValueSource: "",
    dutyCustomValue: 0,
    cdParameters: {
      title: "",
      text: "",
      buttonPosition: "right",
      width: 330,
    },
    touched: false,
    violations: [],
    canForceCreate: false,
    forceCreate: false,
  }),

  computed: {
    ...mapGetters({
      seriesTypes: types.SERIES_TYPES,
      seriesRepetitionTypes: types.SERIES_REPETITION_TYPES,
      seriesMonthlyRepetitionTypes: types.SERIES_MONTHLY_REPETITION_TYPES,
      dutyValueSourceTypes: types.DUTY_VALUE_SOURCE_TYPES,
    }),
    ...mapState({
      userData: (state) => state.app.userSession,
      groupData: (state) => state.app.group,
      userGroups: state => state.app.groups,
      groupScales: (state) => state.app.groupScales,
      groupUsers: (state) => state.app.groupUsers,
      loadingGroupData: (state) =>
        state.app.listeners.loadingGroupDetails === "yes",
    }),
    groups: function () {
      if (this.userGroups && this.userGroups.length) {
        return this.userGroups.map((group) => ({
          key: group.groupID,
          value: group.groupID,
          text: group.groupName,
        }));
      }
      return [];
    },
    dateLanguage() {
      return dateTimeLanguage;
    },
    weekdaysList() {
      return weekdaysValues.map((item) => ({
        key: item.key,
        value: item.key,
        text: item.text,
        checked: this.weekdays.includes(item.value),
      }));
    },
    weeklyRepetition() {
      return SERIES_REPETITION_WEEKLY;
    },
    monthlyRepetition() {
      return SERIES_REPETITION_MONTHLY;
    },
    vacationType() {
      return SERIES_VACATION;
    },
    workingDayType() {
      return SERIES_WORKING_DAY;
    },
    dutyValueSourceCustom() {
      return DUTY_VALUE_SOURCE_CUSTOM;
    },
    dutyValueSourceUserGroup() {
      return DUTY_VALUE_SOURCE_USER_GROUP;
    },
    dutyValueSourceUserScale() {
      return DUTY_VALUE_SOURCE_USER_SCALE;
    },
    monthlyRepetitionTypes() {
      const initialDate = this.period?.length ? this.period[0] : undefined;
      const initialDay = initialDate ? initialDate.split("/")[0] : undefined;
      const initialWeekday = initialDate
        ? moment(initialDate, "DD/MM/YYYY").weekday()
        : undefined;
      const weekOfMonth = initialDate
        ? Math.ceil(moment(initialDate, "DD/MM/YYYY").date() / 7)
        : undefined;
      return this.seriesMonthlyRepetitionTypes.map((item) => {
        let text = item.text;
        if (
          initialDay &&
          item.key === SERIES_REPETITION_MONTHLY_ON_DAY_OF_MONTH
        ) {
          text = `Todo dia ${initialDay} do mês`;
        }
        if (
          initialWeekday !== undefined &&
          weekOfMonth &&
          item.key === SERIES_REPETITION_MONTHLY_ON_WEEKDAY
        ) {
          const weekdaysMap = [
            "domingo",
            "segunda-feira",
            "terça-feira",
            "quarta-feira",
            "quinta-feira",
            "sexta-feira",
            "sábado",
          ];
          const weekOfMonthMap = [
            "",
            "primeir",
            "segund",
            "terceir",
            "quart",
            "quint",
          ];
          const weekdayName = weekdaysMap[initialWeekday];
          const maleGender = initialWeekday === 6 || initialWeekday === 0;
          text = `${maleGender ? "Todo" : "Toda"} ${
            weekOfMonthMap[weekOfMonth]
          }${maleGender ? "o" : "a"} ${weekdayName} do mês`;
        }
        return {
          key: item.key,
          value: item.key,
          text,
        };
      });
    },
    scalesList() {
      return this.groupScales.map((item) => ({
        key: item.scaleID,
        value: item.scaleID,
        text: item.scaleName,
        checked: this.scales.includes(item.scaleID),
      }));
    },
    turnsList() {
      if (!this.scales.length) return [];
      const turns = [];
      this.scales.forEach((scale) => {
        const scaleData = this.groupScales.find(
          (item) => item.scaleID === scale
        );
        const scaleTurns = this.groupScales.find(
          (item) => item.scaleID === scale
        )?.scaleTurnos;
        if (scaleTurns && scaleTurns.length) {
          scaleTurns.forEach((turn) => {
            const endTime = calculateEndTime(
              valueToTime(turn.turnStart),
              formatDbTime(turn.turnDuration)
            );
            turns.push({
              key: turn.turnID,
              value: turn.turnID,
              text: `${scaleData.scaleName} - ${turn.turnStart} às ${endTime} horas`,
              checked: this.turns.includes(turn.turnID),
            });
          });
        }
      });
      return turns;
    },
    usersList() {
      return this.groupUsers.map((item) => ({
        key: item.userID,
        value: item.userID,
        text: item.userName,
        checked: this.users.includes(item.userID),
      }));
    },
    filteredSerieRepetitionTypes() {
      if (this.type === SERIES_VACATION) {
        return this.seriesRepetitionTypes.filter(
          (item) => item.key === SERIES_REPETITION_DAILY
        );
      }
      return this.seriesRepetitionTypes;
    },
  },

  watch: {
    type(newValue) {
      if (newValue && newValue === SERIES_VACATION) {
        this.repetition = SERIES_REPETITION_DAILY;
      }
    },
    scales(newValue) {
      if (newValue) {
        this.turns = [];
      }
    },
  },

  async mounted() {
    if (this.groupId) {
      this.$store.dispatch("loadGroupPage", this.groupId);
      this.$store.dispatch("loadGroupUsersAll", this.groupId);
    }
    this.getSeriesTypes();
    this.getSeriesRepetitionTypes();
    this.getSeriesMonthlyRepetitionTypes().then((response) => {
      if (response?.data?.length) {
        this.monthlyRepetitionType = response.data[0].key;
      }
    });
    this.getDutyValueSourceTypes();
    if (this.id !== null) {
      this.getById(this.id)
        .then((response) => {
          const {
            name,
            type,
            repetition,
            weekdays,
            monthly_repetition_type,
            scales,
            turns,
            users,
            duty_value_source_type,
            duty_custom_total_value,
            start_date,
            end_date,
          } = response.data;
          this.name = name;
          this.type = type || "";
          this.repetition = repetition || "";
          this.weekdays = weekdays;
          this.monthlyRepetitionType = monthly_repetition_type || "";
          this.scales = scales;
          this.users = users;
          this.dutyValueSource = duty_value_source_type || "";
          this.dutyCustomValue = duty_custom_total_value;
          this.period = [
            moment(start_date).format("DD/MM/YYYY"),
            moment(end_date).format("DD/MM/YYYY"),
          ];
          this.touched = true;
          this.$nextTick(() => {
            this.turns = turns;
          });
        })
        .catch((error) => {
          const errorData = error?.response?.data || {
            title: "Erro",
            message: "Erro ao carregar série",
          };
          this.showMessage(errorData.title, errorData.message);
        });
    }
  },

  methods: {
    ...mapActions({
      getSeriesTypes: types.GET_SERIES_TYPES,
      getSeriesRepetitionTypes: types.GET_SERIES_REPETITION_TYPES,
      getSeriesMonthlyRepetitionTypes:
        types.GET_SERIES_MONTHLY_REPETITION_TYPES,
      getDutyValueSourceTypes: types.GET_DUTY_VALUE_SOURCE_TYPES,
      saveSeries: types.SAVE_SERIES,
      getById: types.GET_SERIES_BY_ID,
    }),
    save() {
      this.loading = true;
      this.touched = true;
      if (!this.formIsValid()) {
        this.loading = false;
        return;
      }
      const payload = {
        name: this.name,
        type: this.type,
        repetition: this.repetition,
        weekdays: this.weekdays,
        monthly_repetition_type: this.monthlyRepetitionType,
        start_date: this.formatDate(this.period[0]),
        end_date: this.formatDate(this.period[1]),
        group_id: this.groupId !== null ? this.groupId : this.selectedGroupId,
        scales: this.scales,
        turns: this.turns,
        users: this.users,
        duty_value_source_type: this.dutyValueSource || undefined,
        duty_custom_total_value: this.dutyCustomValue || 0,
        force_create: this.forceCreate,
      };

        this.saveSeries(payload)
        .then((response) => {
          const code = response.data?.code;
          const message = response.data?.message || "";

          const isSuccess =
            code === "OK" ||
            code === 200 ||
            code === 1 ||
            code === 0 ||
            code === "SUCCESS";

          if (!isSuccess) {
            const { violations = [], can_force_create } = response.data?.data || {};

            this.violations = violations;
            this.canForceCreate = can_force_create;

            let errorMessage = "<p>A criação desta série viola as regras de carga horária definidas";

            if (violations.length) {
              errorMessage += ":</p><ul>";
              for (const violation of violations) {
                errorMessage += `<li>${violation.message} (${
                  violation.date
                } - Turno: ${this.getTurnName(violation.turn_id)}</li>`;
              }
              errorMessage += "</ul>";
            } else {
              errorMessage = message || "Erro desconhecido ao salvar série.";
            }

            this.showConfirmBox({
              title: "Atenção",
              text: errorMessage,
              type: "rules-violation",
              data: { can_force_create },
              isResponse: false,
              buttonPosition: "right",
              width: 480,
              closeText: "Cancelar",
              continueText: can_force_create ? "Criar mesmo assim" : "Voltar",
              hideContinue: !can_force_create
            });
            return;
          }

          this.resetForm();
          this.showMessage("Sucesso", "Série criada com sucesso");
        })
        .catch((error) => {
          console.error(error);
          const errorData = error?.response?.data || {
            title: "Erro",
            message: "Erro ao criar série",
          };
          this.showMessage(errorData?.title, errorData?.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    setWeekdays(optionValue, optionText, optionPayload) {
      const index = this.weekdays.indexOf(optionValue);
      if (index > -1) {
        this.weekdays.splice(index, 1);
      } else {
        this.weekdays.push(optionValue);
      }
    },

    setScales(optionValue, optionText, optionPayload) {
      const index = this.scales.indexOf(optionValue);
      if (index > -1) {
        this.scales.splice(index, 1);
      } else {
        this.scales.push(optionValue);
      }
    },

    setTurns(optionValue, optionText, optionPayload) {
      const index = this.turns.indexOf(optionValue);
      if (index > -1) {
        this.turns.splice(index, 1);
      } else {
        this.turns.push(optionValue);
      }
    },

    setUsers(optionValue, optionText, optionPayload) {
      const index = this.users.indexOf(optionValue);
      if (index > -1) {
        this.users.splice(index, 1);
      } else {
        this.users.push(optionValue);
      }
    },

    forceCreateSeries() {
      this.forceCreate = true;
      this.save();
    },

    getTurnName(turnId) {
      const turn = this.turnsList.find((t) => t.key === turnId);
      return turn ? turn.text : turnId;
    },

    formatDate(date) {
      if (!date) return undefined;
      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },

    formIsValid() {
      if (!this.name) {
        return false;
      }
      if (!this.type) {
        return false;
      }
      if (!this.repetition) {
        return false;
      }
      if (this.repetition === this.weeklyRepetition && !this.weekdays.length) {
        return false;
      }
      if (
        this.repetition === this.monthlyRepetition &&
        !this.monthlyRepetitionType
      ) {
        return false;
      }
      if (!this.period?.length) {
        return false;
      }
      if (!this.scales.length) {
        return false;
      }
      if (!this.turns.length) {
        return false;
      }
      if (!this.users.length) {
        return false;
      }
      if (!this.dutyValueSource && this.type === SERIES_WORKING_DAY) {
        return false;
      }
      if (
        this.dutyValueSource === DUTY_VALUE_SOURCE_CUSTOM &&
        !this.dutyCustomValue
      ) {
        return false;
      }
      return true;
    },
    resetForm() {
      this.name = "";
      this.type = "";
      this.repetition = "";
      this.weekdays = [];
      this.monthlyRepetitionType = "";
      this.period = undefined;
      this.scales = [];
      this.turns = [];
      this.users = [];
      this.dutyValueSource = "";
      this.dutyCustomValue = 0;
      this.selectedGroupId = "";
      this.touched = false;
    },
    openCancelDialog() {
      this.showDialog(
        "Deseja cancelar?",
        "Todas as alterações serão perdidas. Deseja continuar?",
        "cancel",
        undefined
      );
    },
    cdAction(cdResponse) {
      if (cdResponse === false && cdResponse.cdType !== "cancel") {
        this.$router.go(-1);
      }
      if (cdResponse === false) return;
      if (cdResponse.cdType === "cancel") {
        this.$router.go(-1);
      }
      if (
        cdResponse.cdType === "rules-violation" &&
        cdResponse.cdData.can_force_create
      ) {
        this.forceCreateSeries();
      }
    },
    setType(value) {
      this.type = value;
    },
    setRepetition(value) {
      this.repetition = value;
    },
    setMonthlyRepetitionType(value) {
      this.monthlyRepetitionType = value;
    },
    setSelectedGroup(selectedGroupId) {
      this.selectedGroupId = selectedGroupId;
      this.scales = [];
      this.turns = [];
      this.users = [];
      this.dutyValueSource = "";
      this.dutyCustomValue = "";
      this.$store.dispatch("loadGroupPage", this.selectedGroupId);
      this.$store.dispatch("loadGroupUsersAll", this.selectedGroupId);
    },
    setDutyValueSource(value) {
      this.dutyValueSource = value;
    },
    onBlurDutyCustomValue(value) {
      this.dutyCustomValue = value;
    },
  },
};
</script>

<style lang="scss" scoped>
.blockTitle {
  color: #305050;
  font-size: 30px;
  line-height: 40px;
}

#pageHeader {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 30px;
  min-height: 100px;
}

#blockSeriesForm {
  position: relative;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding-top: 35px;
  padding-bottom: 25px;
  margin-bottom: 15px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  color: rgba(0, 0, 0, 0.87);
}

.saveSeriesField {
  .v-text-field {
    .v-input__slot:before,
    .v-input__slot:after {
      display: none;
    }
  }

  .v-text-field .v-input__append-inner {
    margin: 0 !important;
    padding: 0 !important;
    align-self: center !important;
  }
}
</style>
